export function Home({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13.9926V11.7426M6.765 2.63012L2.7225 5.78012C2.0475 6.30512 1.5 7.42262 1.5 8.27012V13.8276C1.5 15.5676 2.9175 16.9926 4.6575 16.9926H13.3425C15.0825 16.9926 16.5 15.5676 16.5 13.8351V8.37512C16.5 7.46762 15.8925 6.30512 15.15 5.78762L10.515 2.54012C9.465 1.80512 7.7775 1.84262 6.765 2.63012Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
